import { render, staticRenderFns } from "./ConfigPdfTemplates.vue?vue&type=template&id=6306b2ca&scoped=true&"
import script from "./ConfigPdfTemplates.vue?vue&type=script&lang=js&"
export * from "./ConfigPdfTemplates.vue?vue&type=script&lang=js&"
import style0 from "./ConfigPdfTemplates.vue?vue&type=style&index=0&id=6306b2ca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6306b2ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
